export default __webpack_public_path__ + "static/media/Truck1.6e89eb08.gif";